import script from "./RatingsReviews.vue?vue&type=script&lang=ts&setup=true"
export * from "./RatingsReviews.vue?vue&type=script&lang=ts&setup=true"

import "./RatingsReviews.vue?vue&type=style&index=0&id=603cf0ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-603cf0ea"]])

export default __exports__